import React from "react";
import STYLE from "./Top.module.css"

export function Top() {
    return (

        <div
            className={STYLE.topMaxSize}>
            Ofera un buchet de vara si surprinde-ti persoana draga. Livrare in toata tara in 2-4 ore prin curieri proprii.
        </div>

    )
}